import { Permissions } from "@cnx/common";
import {
  IconBriefcase,
  IconCalendarCancel,
  IconUsersGroup,
} from "@tabler/icons-react";
import IconCash from "assets/icons/payroll/cash.svg";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { useAuthStore } from "stores/authStore";
import { Link } from "types/Link";

export const usePayrollLinks = () => {
  const useRights = new Set(useAuthStore(state => state.useRights));
  const { t } = useTranslation();
  const { pathname: currentPath } = useLocation();

  const payrollLinks: Link[] = [];

  useRights.has(Permissions.RIGHTS_PAYROLL_ADMIN) &&
    payrollLinks.push({
      isActive: currentPath.startsWith("/payroll-types"),
      link: "/payroll-types",
      icon: <IconCash className="w-6 h-6" />,
      label: t("payrollType"),
    });
  useRights.has(Permissions.RIGHTS_PAYROLL_ADMIN) &&
    payrollLinks.push({
      isActive: currentPath.startsWith("/work-types"),
      link: "/work-types",
      icon: <IconBriefcase />,
      label: t("workType"),
    });
  useRights.has(Permissions.RIGHTS_PAYROLL_ADMIN) &&
    payrollLinks.push({
      isActive: currentPath.startsWith("/absence-types"),
      link: "/absence-types",
      icon: <IconCalendarCancel />,
      label: t("absenceType"),
    });
  useRights.has(Permissions.RIGHTS_PAYROLL_ADMIN) &&
    payrollLinks.push({
      isActive: currentPath.startsWith("/pay-groups"),
      link: "/pay-groups",
      icon: <IconUsersGroup />,
      label: t("payGroup"),
    });

  return payrollLinks;
};
